import { InjectionToken } from '@angular/core';

/** One entry of `allowed_methods` in a 403 `insufficient_amr` body. */
export interface StepUpMethodDto {
  type: 'idp' | 'amr';
  value: string;
  alias?: string;
  name: string;
}

/** Offers the user a stronger login for the scope a request was refused on. */
export interface StepUpGate {
  request(methods: StepUpMethodDto[]): void;
}

/** Ignores every request, for applications that provide no gate. */
export class NoopStepUpGate implements StepUpGate {
  public request(): void {}
}

export const STEP_UP_GATE = new InjectionToken<StepUpGate>('step-up-gate', {
  providedIn: 'root',
  factory: () => new NoopStepUpGate(),
});
